<template>
	<div class="settings-info-banner" :class="statusClass">
		<InfoCircleOutlined v-if="isInfo" class="pd-sm-x" />
		<WarningTwoTone v-else :two-tone-color="pink" class="pd-sm-x" />
		<TypographyText><slot /></TypographyText>
	</div>
</template>

<script>
import { computed, toRef } from 'vue';
import { TypographyText } from 'ant-design-vue';
import { InfoCircleOutlined, WarningTwoTone } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';

export default {
	components: {
		TypographyText,
		InfoCircleOutlined,
		WarningTwoTone,
	},
	props: {
		status: {
			type: String,
			default: 'info',
		},
	},
	setup(props) {
		const statusRef = toRef(props, 'status');
		const isInfo = computed(() => statusRef.value !== 'warning');
		const statusClass = computed(() => (
			isInfo.value ? 'settings-info-banner--info' : 'settings-info-banner--warning'
		));
		return {
			isInfo,
			statusClass,
			pink: Consts.COLORS.pink,
		};
	},
};
</script>

<style scoped>
.settings-info-banner {
	display: flex;
	align-items: baseline;
	padding: 8px;
	border-radius: 6px;
}
.settings-info-banner--info {
	border: 1px solid #91d5ff;
	background-color: #e6f7ff;
	color: #1890ff;
}
.settings-info-banner--warning {
	border: 1px solid v-bind(pink);
	background-color: #fff0f6;
	color: v-bind(pink);
}
.settings-info-banner :deep(.ant-typography) {
	color: inherit;
}
</style>
